export const regexp = () => {
    return {
      'emailRegExp': /\S+@\S+\.\S+/,
      'phoneRegExp': /^(\d{3}[-]?){1,2}(\d{4})$/,
      'numericRegExp': /^[0-9]*\.?[0-9]*$/,
    }
  }